import { listenerCount } from "cluster"

class BrowserCheck {
    constructor() {
        this._init()
    }
    _init() {
        this.isIE = this.checkIfIE() 
        if(!this.isIE) {
            return
        }

        this.elBody = document.querySelector('[data-body]')
        if(!this.elBody) {
            return
        }
        this.elBody.innerHTML = ""
        this.setNewHtml()
        this.elBody.style.paddingTop = '66px'
    }
    checkIfIE() {
        var ua = window.navigator.userAgent
        var msie = ua.indexOf("MSIE ")

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            return true
        }
        
        return false
    }
    setNewHtml() {
        var xhttp = new XMLHttpRequest()
        const loc = window.location;
        let path = loc.pathname.split('/')
        let origin = loc.protocol + "//" + loc.host
        let link = origin + "/" + path[1] + "/?&outdated=yes"
        xhttp.onreadystatechange = e => {
            if (e.target.readyState == 4 && e.target.status == 200) {
                // Typical action to be performed when the document is ready:
                this.elBody.innerHTML = xhttp.responseText
            }
        }
        xhttp.open("GET", link, true)
        xhttp.send()
    }
}

export default BrowserCheck